import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { getBreakpoint } from './_utils';

const classes = {
	warningModal: 'WarningModal',
	warningModalTitle: 'WarningModal-title',
	warningModalTextContainer: 'WarningModal-textContainer',
	warningModalTextContainerScroll: 'WarningModal-textContainer--scrollable',
	warningModalText: 'WarningModal-text',
	warningModalTextScroll: 'WarningModal-text--scrollable',
	warningModalOpen: 'WarningModal--opened',
	warningModalCta: 'WarningModal-cta',
	warningModalWithImage: 'WarningModal-content-withImage',
};

const selectors = {
	warningModal: `.${classes.warningModal}`,
	openModal: `.${classes.warningModalOpen}`,
	warningModalTitle: `.${classes.warningModalTitle}`,
	warningModalTextContainer: `.${classes.warningModalTextContainer}`,
	warningModalText: `.${classes.warningModalText}`,
	warningModalCta: `.${classes.warningModalCta}`,
	warningModalOpenTrigger: '[data-modal-open]',
	warningModalCloseTrigger: '[data-modal-close]',
	bgDisabledItems: 'a, button, select, input',
	bgExcludedItems: `:not(.${classes.warningModal} *)`,
	warningModalWithImage: `.${classes.warningModalWithImage}`,
};

const $bgDisabledItems = $(selectors.bgDisabledItems).filter(selectors.bgExcludedItems);

const ESCAPE_KEYCODE = 27;
const $window = $(window);

/**
 * Adds all the functionality required to open the modal.
 */
function setupModal() {
	const $warningModal = $(selectors.warningModal);
	const $warningModalTitle = $(selectors.warningModalTitle);
	const $warningModalTextContainer = $(selectors.warningModalTextContainer);
	const $warningModalText = $(selectors.warningModalText);
	const $warningModalCta = $(selectors.warningModalCta);
	const $openTrigger = $(selectors.warningModalOpenTrigger);
	const $closeTrigger = $(selectors.warningModalCloseTrigger);
	const isWithImage = $(selectors.warningModalWithImage).length > 0;
	let $targetCta;

	const openModal = e => {
		if ($warningModal.length > 0) {
			$targetCta = $(e.target);
			const modalId = $targetCta.attr('data-modal-open');

			let $warningModalToOpen = $warningModal;
			if (modalId) {
				$warningModalToOpen = $(`#${modalId}`);
			}

			e.preventDefault();
			disableBodyScroll($warningModalToOpen[0], {
				// strictly needed for iOS
				allowTouchMove: el => $warningModalToOpen[0].contains(el),
			});
			const elementLink = $targetCta.data('modal-link');
			$warningModalCta.attr('href', elementLink);
			$warningModalToOpen.addClass(classes.warningModalOpen);
			$warningModalToOpen.fadeIn(300);
			$warningModalCta.focus();
			setWarningModalTextMaxHeight();
			makeTextContainerScrollable();

			$bgDisabledItems.attr('tabindex', -1);

			//emit events
			window.dispatchEvent(new CustomEvent('fsModalOpened', { detail: { modalId } }));
			$warningModalToOpen.find('.lazy-render').trigger('react.mount');
		}
	};

	const closeModal = () => {
		const openModal = $(selectors.openModal);
		if (openModal.length) {
			enableBodyScroll(openModal[0]);
			openModal.removeClass(classes.warningModalOpen);
			openModal.fadeOut(300);
			$targetCta.focus();
			$bgDisabledItems.removeAttr('tabindex');

			//emit events
			window.dispatchEvent(
				new CustomEvent('fsModalClosed', { detail: { modalId: openModal.attr('id') } })
			);
			openModal.find('.lazy-render').trigger('react.unmount');
		}
	};

	// Calculate the max-height of the text container dynamically.
	// We substract the fixed space of the title and the cta from the
	// viewport height. Then that max-height is set to the text element,
	// so that, the text container looks good in each viewport height when in
	// small viewport.
	const setWarningModalTextMaxHeight = () => {
		const warningModalPaddingTop = 76;
		const warningTitleHeight = $warningModalTitle.outerHeight();
		const warningCtaHeight = $warningModalCta.outerHeight();
		const textContainerMaxHeight =
			window.innerHeight -
			window.innerHeight * 0.1 -
			warningModalPaddingTop -
			warningTitleHeight -
			warningCtaHeight;
		$warningModalText.css('max-height', `${textContainerMaxHeight}px`);
	};

	const getWarningModalTextMaxHeight = () => {
		return parseInt($warningModalText.css('max-height'));
	};

	const matchTextContainerMaxHeight = () => {
		const textContainerMaxHeight = getWarningModalTextMaxHeight();
		const textContainerHeight = $warningModalTextContainer.innerHeight();
		return !isWithImage && textContainerHeight >= textContainerMaxHeight;
	};

	const makeTextContainerScrollable = () => {
		if (getBreakpoint() === 'small' && matchTextContainerMaxHeight()) {
			$warningModalTextContainer.addClass(classes.warningModalTextContainerScroll);
			$warningModalText.addClass(classes.warningModalTextScroll);
		} else {
			$warningModalTextContainer.removeClass(classes.warningModalTextContainerScroll);
			$warningModalText.removeClass(classes.warningModalTextScroll);
			$warningModalText.css('max-height', '');
		}
	};

	const onResize = () => {
		setWarningModalTextMaxHeight();
		makeTextContainerScrollable();
	};

	$warningModalCta.on('click', closeModal);

	$openTrigger.on('click', openModal);
	$closeTrigger.on('click', closeModal);

	$window.on('resize', onResize);

	$(document).on('keyup', e => {
		if (e.keyCode === ESCAPE_KEYCODE && $warningModal.hasClass(classes.warningModalOpen)) {
			closeModal();
		}
	});
}

export default function init() {
	setupModal();
}
